import React from "react";
import {
  Clock, CheckCircle2, Flag, ShieldAlert, UserCheck, UserX, ScanFace,
  MapPin, Ban, WifiOff, Crosshair, LoaderCircle, ShieldQuestion,
} from "lucide-react";
import { useLang } from "@/lib/i18n";
import { cn } from "@/lib/utils";

const REVIEW = {
  pending: { icon: Clock, cls: "bg-secondary text-foreground border-border", key: "pending" },
  approved: { icon: CheckCircle2, cls: "bg-emerald-50 text-emerald-800 border-emerald-200", key: "approved" },
  flagged: { icon: Flag, cls: "bg-amber-50 text-amber-900 border-amber-200", key: "flagged" },
  overridden: { icon: ShieldAlert, cls: "bg-slate-100 text-slate-900 border-slate-300", key: "overridden" },
};

const MATCH = {
  pass: { icon: UserCheck, cls: "bg-emerald-50 text-emerald-800 border-emerald-200", key: "matchPass" },
  fail: { icon: UserX, cls: "bg-rose-50 text-rose-900 border-rose-200", key: "matchFail" },
  no_face_detected: { icon: ScanFace, cls: "bg-amber-50 text-amber-900 border-amber-200", key: "noFace" },
  // Batch 34: recorded while the face engine was unreachable; auto re-verified later
  unverified: { icon: ShieldQuestion, cls: "bg-amber-50 text-amber-900 border-amber-200", key: "matchUnverified" },
};

const LOCATION = {
  ok: { icon: MapPin, cls: "bg-sky-50 text-sky-900 border-sky-200", key: "locOk" },
  denied: { icon: Ban, cls: "bg-amber-50 text-amber-900 border-amber-200", key: "locDenied" },
  unavailable: { icon: WifiOff, cls: "bg-slate-100 text-slate-900 border-slate-300", key: "locUnavailable" },
  low_accuracy: { icon: Crosshair, cls: "bg-amber-50 text-amber-900 border-amber-200", key: "locLowAccuracy" },
  acquiring: { icon: LoaderCircle, cls: "bg-slate-100 text-slate-900 border-slate-300", key: "gpsAcquiring", spin: true },
};

const KINDS = { review: REVIEW, match: MATCH, location: LOCATION };

export const StatusBadge = ({ kind, value, className, testId }) => {
  const { t } = useLang();
  const def = KINDS[kind]?.[value];
  if (!def) return null;
  const Icon = def.icon;
  return (
    <span
      data-testid={testId || `badge-${kind}-${value}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap",
        def.cls, className,
      )}
    >
      <Icon className={cn("h-3.5 w-3.5", def.spin && "animate-spin")} />
      {t(def.key)}
    </span>
  );
};
